// lower index == higher priority for token import
export const DEFAULT_LIST_OF_LISTS: string[] = [];

// default lists to be 'active' aka searched across
export const DEFAULT_ACTIVE_LIST_URLS: string[] = [];
